module.exports = __webpack_public_path__ + "static/media/14.6f153899.png";